/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

export { default as fitScreenWidth } from '@/styles/Default/additives/fitScreenWidth';
export { default as coverTapTarget } from '@/styles/Default/additives/coverTapTarget';

// migrated additives for class-name symmetry from ReactJS store
export { default as freeDeliveryContent } from '@/styles/Default/additives/migrated/freeDeliveryContent';
export { default as heroMessage } from '@/styles/Default/additives/migrated/heroMessage';
export { default as homeHeroContent } from '@/styles/Default/additives/migrated/homeHeroContent';
export { default as increaseTextContrast } from '@/styles/Default/additives/migrated/increaseTextContrast';
export { default as marketingBackgroundImage } from '@/styles/Default/additives/migrated/marketingBackgroundImage';
export { default as marketingButton } from '@/styles/Default/additives/migrated/marketingButton';
export { default as marketingContent } from '@/styles/Default/additives/migrated/marketingContent';
export { default as marketingFullscreenBanner } from '@/styles/Default/additives/migrated/marketingFullscreenBanner';
export { default as marketingHeroImage } from '@/styles/Default/additives/migrated/marketingHeroImage';
export { default as marketingText } from '@/styles/Default/additives/migrated/marketingText';
export { default as parallaxLayer } from '@/styles/Default/additives/migrated/parallaxLayer';
export { default as parallaxLayerBack } from '@/styles/Default/additives/migrated/parallaxLayerBack';
export { default as parallaxLayerBase } from '@/styles/Default/additives/migrated/parallaxLayerBase';
export { default as percentOffContent } from '@/styles/Default/additives/migrated/percentOffContent';
export { default as primary } from '@/styles/Default/additives/migrated/primary';
export { default as promoLarge } from '@/styles/Default/additives/migrated/promoLarge';
export { default as promoLargeMessage } from '@/styles/Default/additives/migrated/promoLargeMessage';
export { default as promoMedium } from '@/styles/Default/additives/migrated/promoMedium';
export { default as promoMediumMessage } from '@/styles/Default/additives/migrated/promoMediumMessage';
export { default as promoSmallContainer } from '@/styles/Default/additives/migrated/promoSmallContainer';
export { default as sapphireOrderManagementContent } from '@/styles/Default/additives/migrated/sapphireOrderManagementContent';
export { default as sapphirePercentOffContent } from '@/styles/Default/additives/migrated/sapphirePercentOffContent';
export { default as textHero } from '@/styles/Default/additives/migrated/textHero';
export { default as textShadow } from '@/styles/Default/additives/migrated/textShadow';
export { default as wchHeroImage } from '@/styles/Default/additives/migrated/wchHeroImage';
